import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Pause from "../common/Pause";

const CampaignPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const campaignName = log.dataSnapshot?.campaign?.name;
  const {
    campaign: { updatedAt, updatedBy },
  } = log.changedFields;
  return <Pause name={campaignName} updatedAt={updatedAt} updatedBy={updatedBy} />;
};

export default CampaignPaused;
